// @ts-strict-ignore
/* eslint-disable react/no-this-in-sfc */
import React from 'react';
import { Chart } from '@usealloy/component-library';

import type { RuleBreakdownProps } from '../RuleCard/RuleBreakdown';

import type { ChartLevels } from './types';

import {
  colorDataLineByThresholdOperatorAndValue,
  colorPlotBandsByThresholdOperatorAndValue,
  colorPlotLinesByThresholdOperatorAndValue,
} from './helpers';
import { DARK_GRAY } from './constants';


export type ThresholdsLineChartProps = {
  bandValue: number;
  chartLevels: ChartLevels;
  breakdownMap: Map<number, number>;
  thresholdOperator: string;
  thresholdType: RuleBreakdownProps['thresholdType'];
};

const ThresholdsLineChart: React.FC<ThresholdsLineChartProps> = ({
  bandValue,
  chartLevels,
  breakdownMap,
  thresholdOperator,
  thresholdType,
}) => (
  <Chart.Line
    data={[
      {
        name: '',
        data: Array.from(breakdownMap, (value => value)) || [],
      },
    ]}
    annotations={colorPlotLinesByThresholdOperatorAndValue({
      bandValue, breakdownMap, chartLevels, operator: thresholdOperator,
    }).map(plotLine => ({
      ...plotLine,
      xCoord: plotLine.value,
    }))}
    width={820}
    colorZones={colorDataLineByThresholdOperatorAndValue({
      bandValue, breakdownMap, chartLevels, operator: thresholdOperator,
    })}
    colorZoneAxis="x"
    lineWidth={2}
    xMin={1}
    xMax={99}
    xAxisLabel="% of Evaluations"
    xAxisLabelAlign="high"
    xAxisPlotBands={colorPlotBandsByThresholdOperatorAndValue({
      bandValue, breakdownMap, chartLevels, operator: thresholdOperator,
    })}
    xAxisPlotLineColor={DARK_GRAY}
    xAxisPlotLineWidth={1}
    xAxisPlotLineDashStyle="Dash"
    xAxisPlotLineLabelEnabled={false}
    xAxisTickInterval={10}
    yAxisLabel={thresholdType}
    yAxisLabelAlign="high"
    yAxisLabelFormatter={(value: number) => {
      // Truncate long decimals to 2 places, but don't include trailing 0s
      if (value % 1 !== 0) {
        return value
          .toLocaleString('en-US', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          });
      }
      // Return comma separated format for whole values
      return value.toLocaleString('en-US', { maximumFractionDigits: 0 });
    }}
    yAxisGridLineWidth={1}
    yAxisGridLineDashStyle="LongDash"
    disableMarker
    hideTooltipHeader
    hideTooltipTotals
  />
);

export default ThresholdsLineChart;
